import { Component } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ModalController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { AuthService } from "src/app/_services/auth.service";
import { LocalStorageService } from "src/app/_services/localStorage.service";

@Component({
  selector: "app-forced-phone-completion-modal",
  templateUrl: "./forced-phone-completion-modal.component.html",
  styleUrls: ["./forced-phone-completion-modal.component.scss"],
  standalone: false,
})
export class ForcedPhoneCompletionModalComponent {
  submitted = false;
  loading = false;
  role: string;
  serverError = "";
  form: FormGroup;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private localStorageService: LocalStorageService,
    private modalController: ModalController,
    private translate: TranslateService
  ) {
    this.role = this.localStorageService.getUserRole();
    this.form = this.fb.group({
      phone_field: [null, Validators.required],
    });
  }

  submit(): void {
    this.submitted = true;
    this.serverError = "";
    if (!this.form.valid) {
      return;
    }

    const phone = this.formatPhoneForSubmission(this.form.value.phone_field);
    if (!phone) {
      this.serverError = this.translate.instant("MODALS.PHONE_COMPLETION.ERROR_REQUIRED");
      return;
    }

    const currentUser = this.localStorageService.getUserData()?.client;
    if (!currentUser) {
      this.serverError = this.translate.instant("MODALS.PHONE_COMPLETION.ERROR_UPDATE");
      return;
    }

    const payload = {
      first_name: currentUser.first_name || "",
      last_name: currentUser.last_name || "",
      email: currentUser.email || "",
      gender: currentUser.gender,
      password: "",
      phone,
    };

    this.loading = true;
    this.authService.updateUser(payload).subscribe({
      next: (res: any) => {
        this.loading = false;
        const updatedUser = res?.body?.data?.user || res?.body?.user;
        if (updatedUser) {
          this.localStorageService.updateUser(updatedUser);
        } else {
          this.localStorageService.updateUser({ ...currentUser, phone });
        }
        this.modalController.dismiss({ updated: true }, "updated");
      },
      error: () => {
        this.loading = false;
        this.serverError = this.translate.instant("MODALS.PHONE_COMPLETION.ERROR_UPDATE");
      },
    });
  }

  private formatPhoneForSubmission(phoneField: any): string {
    if (!phoneField) {
      return "";
    }
    let value: string = (phoneField.phone != null ? String(phoneField.phone) : "").trim();
    if (!value) {
      return "";
    }
    const dial = phoneField.dialCode || "";
    if (!value.startsWith("+") && dial) {
      value = `${dial} ${value}`;
    }
    return value.replace(/\s+/g, "");
  }
}
